import { useQuery } from '@apollo/client';
import { Loading as LoadingIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Loading';
import PropTypes from 'prop-types';
import React from 'react';

import ErrorMessage from '../ErrorMessage';
import LoadingWrapper from './styled';

const PageQuery = ({
  query,
  variables,
  children,
  errorElement,
  showLoader,
  ...props
}) => {
  const state = useQuery(query, {
    variables,
    ...props,
    errorPolicy: 'ignore',
  });

  const { error, networkStatus, data } = state;

  // Only show loading on initial load, but not during 'refetch' status.
  // This makes sure the page keeps showing the existing items when loading
  // new items.
  const loading = networkStatus < 3;

  if (loading && showLoader) {
    return (
      <LoadingWrapper>
        <LoadingIcon />
      </LoadingWrapper>
    );
  }

  if (error || !data) return errorElement;

  return children(state);
};

PageQuery.defaultProps = {
  errorElement: <ErrorMessage />,
  showLoader: true,
};

PageQuery.propTypes = {
  query: PropTypes.shape().isRequired,
  variables: PropTypes.shape().isRequired,
  children: PropTypes.func.isRequired,
  showLoader: PropTypes.bool,
  errorElement: PropTypes.node,
};

export default PageQuery;
